export default __webpack_public_path__ + "static/media/NuclearPowerplant.256.5ff1b616.png";